import { render } from "./supporter-info-panel.vue?vue&type=template&id=531546f0&scoped=true&ts=true"
import script from "./supporter-info-panel.vue?vue&type=script&lang=ts"
export * from "./supporter-info-panel.vue?vue&type=script&lang=ts"

import "./supporter-info-panel.vue?vue&type=style&index=0&id=531546f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531546f0"]])

export default __exports__